<template>
    <router-view v-if="categories.length"/>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name:     'Download',
        computed: {
            ...mapGetters('download', ['categories'])
        },
        mounted() {
            this.fetchCategories();
        },
        methods:  {
            ...mapActions('download', ['fetchCategories']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/download/Download.vue